import { Capacitor } from '@capacitor/core';

// True when running inside the native iOS/Android (Capacitor) app, false on web.
// Used to comply with App Store Guideline 3.1.1: the native app must not offer
// account registration or external subscription/payment mechanisms. Those flows
// stay on the web build only.
export const isNativeApp = Capacitor.isNativePlatform();
